import React from 'react'
import classes from '@src/styles/WarriorTestimonial.module.css'
import losAngeles from '@src/assets/warrior-testimonials/los-angeles.jpg'
import sanJose from '@src/assets/warrior-testimonials/san-jose.jpg'
import sanFrancisco from '@src/assets/warrior-testimonials/san-francisco.jpg'
import atlanta from '@src/assets/warrior-testimonials/atlanta.jpg'
import { useRouter } from 'next/router'
import { segmentTrack } from '@src/functions/segment'
import queryString from 'query-string'
import { withAttribution } from '@src/functions/attribution'

function WarriorTestimonial() {
  const history = useRouter()

  const handleButtonClick = (userType: string) => {
    // eslint-disable-next-line no-console
    console.log('handleButtonClick : userType', userType)
    // dispatch({ type: 'SET_TEMP_USER', userType })
    history.push(
      withAttribution(
        `${process.env.NEXT_PUBLIC_REDIRECT_URL}?`.concat(
          queryString.stringify({
            login: '1',
          }),
        ),
      ),
    )
    segmentTrack('User Clicks Register - Provider Portal', { userType });
  }

  return (
    <section className={classes.container}>
      <div className={classes.content}>
        <div className={classes.headingContainer}>
          <h2 className={classes.heading}>Get Connected</h2>
          {/* <p className={classes.subHeading}>Join a nationwide network of trusted waste management professionals</p> */}
        </div>
        <div>
          <div className={classes.testimonial}>
            <img alt='' className={classes.testimonialImage} src={atlanta.src} />
            <p className={classes.testimonialLoc}>Atlanta, GA</p>
            <h4 className={classes.testimonialName}>Blake Misajet</h4>
            <p className={classes.testimonialDescription}>
              Found Dimension back in LA before moving to ATL. I work in home building so I have
              access to equipment. I don&apos;t mind doing any type of manual labor, so for me
              it&apos;s really easy to grab jobs and make some money on the side to save up to pay
              down some debt. Very good use of time outside my 9-5. The time value proposition is
              great for me. I can run in and grab 5 trash bags and make 100 bucks in 15 minutes
              which is several hours of work at any other job. It fits my schedule well when and
              where I want it. The user base is great and knows that picking up trash is a luxury,
              and I think a lot of customers are just happy to have a quick easy reliable and
              affordable solution to their trash situations. I found Dimension last summer and was
              just picking up jobs in my free time to make some extra cash.
            </p>
          </div>
          <div className={classes.divider} style={{ width: '100%' }} />
          <div className={classes.testimonial}>
            <img alt='san francisco' className={classes.testimonialImage} src={sanFrancisco.src} />
            <p className={classes.testimonialLoc}>San Francisco, CA</p>
            <h4 className={classes.testimonialName}>Marcos Fernandez</h4>
            <p className={classes.testimonialDescription}>
              Started about two years ago. Before Dimension, I worked at my company for 8 years.
              Used just Yelp before as his main source of business. Dimension gives me great jobs. I
              love my job with Dimension. Good company, great company for us. Dhruv has helped me
              and wife out so well. And he has always helped us out and ready to help. Very happy to
              work for us and appreciates the opportunity. Call me anytime and I&apos;m ready to
              help anytime I can.
            </p>
          </div>
          <div className={classes.divider} style={{ width: '100%' }} />
          <div className={classes.testimonial}>
            <img alt='san jose' className={classes.testimonialImage} src={sanJose.src} />
            <p className={classes.testimonialLoc}>San Jose, CA</p>
            <h4 className={classes.testimonialName}>Joe Pilkington</h4>
            <p className={classes.testimonialDescription}>
              I’ve got the website on my phone 24/7 and sometimes even wake up in the middle of
              night to check to see if there are any jobs available. I’ll check it in the middle of
              the night and find amazing jobs that haven’t been taken yet, and I get really excited
              for the week because I know I’m going to make a lot of money. I’ve always got the
              website up and running on my phone. It’s like a dog chasing a frisbee or going after a
              car. I just love it and it’s addicting.
            </p>
          </div>
          <div className={classes.divider} style={{ width: '100%' }} />
          <div className={classes.testimonial}>
            <img alt='los angeles' className={classes.testimonialImage} src={losAngeles.src} />
            <p className={classes.testimonialLoc}>National Provider</p>
            <h4 className={classes.testimonialName}>Brad from Clean Earth</h4>
            <p className={classes.testimonialDescription}>
              You can put Communication is the key to success! Dimension is awesome to work with
              when we need to close an opportunity quickly.
            </p>
          </div>
          <button className={classes.primaryButton} onClick={() => handleButtonClick('provider')}>
            Sign Up Now
          </button>
        </div>
      </div>
    </section>
  )
}

export default WarriorTestimonial
